// Top-bar breadcrumb (task 355.4 moved it to the shell; 355.7 made the labels readable — type and
// category names from the cached document tree, short ids, no links to section segments without a page).

import React, { useMemo } from 'react';
import { Breadcrumb } from 'antd';
import { Link, useLocation } from 'react-router-dom';
import useDocumentTypeTree from '../../hooks/useDocumentTypeTree';
import { buildCrumbs } from './breadcrumbModel';

function AppBreadcrumb(): React.ReactElement {
  const { pathname } = useLocation();
  const { data: tree } = useDocumentTypeTree();

  const items = useMemo(
    () =>
      buildCrumbs(pathname, tree).map((c) => {
        const label = c.mono ? <code>{c.label}</code> : c.label;
        return { title: c.path ? <Link to={c.path}>{label}</Link> : label };
      }),
    [pathname, tree],
  );

  if (items.length === 0) return <></>;
  return <Breadcrumb items={items} />;
}

export default AppBreadcrumb;
